import { fetchApi } from '../../utils/fetchHelper';
import endpoints from '../../configs/endpoints';

export const fetchProjects = () =>
    fetchApi({ method: 'GET', url: endpoints.projects }, true);

export const createProject = (data) =>
    fetchApi({ method: 'POST', url: endpoints.projects, data }, true);

export const getProject = (id) =>
    fetchApi({ method: 'GET', url: endpoints.projectById(id) }, true);

export const updateProject = (id, data) =>
    fetchApi({ method: 'PATCH', url: endpoints.projectById(id), data }, true);

export const deleteProject = (id) =>
    fetchApi({ method: 'DELETE', url: endpoints.projectById(id) }, true);
